import {Product} from "@/types/entities/product";
import {ActivityOccurrence} from "@/types/entities/activity/activityOccurrence";

export class TinyActivity extends Product {
  pageImage?: File
  savedPageImage?: string
  imageOverlayTextFr?: string
  imageOverlayTextEn?: string
  startsAt?: string;
  endsAt?: string;
  location?: string;
  locationAddress?: string;
  onlineUrl?: string;
  onlinePhoneNumber?: string;
  onlineWebinarNumber?: string;
  surveyUrl?: string;
  trainer?: string;
  maxParticipants?: number;
  isPrivate?: boolean;
  isPublished?: boolean;

  participantGuideUrl?: File;
  activityPresentationUrl?: File;
  activityRecordingUrl?: string;

  firstStartDate?: string;
  lastEndDate?: string;
}

export class Activity extends TinyActivity {
  activityOccurrences: ActivityOccurrence[] = [];
}

export enum ActivityLocation {
  Online = "online",
  InPerson = "presential",
}

export function getActivityLocations(): any {
  return [ActivityLocation.Online, ActivityLocation.InPerson];
}

export function getStartDate(activity: Activity): string | undefined {
  return activity.activityOccurrences && activity.activityOccurrences.length > 0
      ? activity.activityOccurrences[0].startDate
      : undefined;
}

export function getEndDate(activity: Activity): string | undefined {
  return activity.activityOccurrences && activity.activityOccurrences.length > 0
      ? activity.activityOccurrences[activity.activityOccurrences?.length-1].endDate
      : undefined;
}